function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIcons6 = function SvgSurveyIcons6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M34.88 8.52h-3.09V4.81A.76.76 0 0 0 31 4h-3.08a.76.76 0 0 0-.76.76v3.76h-9.25V4.81a.76.76 0 0 0-.76-.76H14a.76.76 0 0 0-.76.76v3.71h-2.88a3.85 3.85 0 0 0-3.86 3.84v2.34a.76.76 0 0 0 .76.76H38a.76.76 0 0 0 .75-.76v-2.33a3.86 3.86 0 0 0-3.87-3.85Z",
    style: {
      fill: "#f68b50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 17.94H7.26a.76.76 0 0 0-.76.76v18.36a3.85 3.85 0 0 0 3.85 3.85h24.53a3.85 3.85 0 0 0 3.85-3.85V18.7a.76.76 0 0 0-.73-.76ZM23.85 36a.7.7 0 0 1-.62.77h-.79a.71.71 0 0 1-.79-.77V24.44l-1.11.56a.67.67 0 0 1-1-.47l-.09-.32a.76.76 0 0 1 .4-1L22.27 22a2.29 2.29 0 0 1 1-.21c.36 0 .58.28.58.77Z",
    style: {
      fill: "#4f6b80"
    }
  }));
};
export default SvgSurveyIcons6;